const moment = require("moment");

function getCILSuccessMessage(time, cilRequestUpdated) {
  if (!cilRequestUpdated) {
    return "You will receive a text message reminding you when it’s time to check in for your service.";
  }

  const timeText = moment().clone().startOf("day").add(time, "seconds").format("h:mm A")

  return `Your Get a Haircut Later request has been updated to ${timeText}. You will receive a text message reminding you when it’s time to check in for your service.`;
}

module.exports = { getCILSuccessMessage };
